import {Field} from "../../containers/QueryBuilder/types/Field"
import {Cell, Query, QueryField} from "../../containers/QueryBuilder/types/Query";
import _ from "lodash";

export const isCountOnlyAgg = (field: Field) => {
    return field.opt !== 'number' && field.opt !== 'percent'
}

export const fieldChoices = (field: Field) => {
    let row = false
    let column = false
    let value = false
    let filter = false

    if (field.value && field.filter) {
        row = false
        column = false
        value = true
        filter = true
    } else if (!field.grouped && !field.filter) {
        row = false
        column = false
        value = true
        filter = false
    } else if (field.grouped && field.filter) {
        row = true
        column = true
        value = false
        filter = true
    } else if (!field.grouped && field.filter) {
        row = false
        column = false
        value = false
        filter = true
    } else if (field.grouped && !field.filter && !(field.opt === "identifier" || field.opt === "number")) {
        row = true
        column = true
        value = false
        filter = false
    } else if (field.grouped && !field.filter && (field.opt === "identifier" || field.opt === "number")) {
        row = true
        column = true
        value = true
        filter = false
    }
    return {
        row: row,
        column: column,
        value: value,
        filter: filter
    }
}

export const calculateExpectedResult = (fields: { [id: string]: Field }, query: Query) => {
    let index = 0
    const rows = query.rows ?? []
    const columns = query.columns ?? []
    const values = query.values ?? []

    if (_.isEmpty(rows) && _.isEmpty(columns) && _.isEmpty(values)) {
        return {}
    }

    const getName = (qf: QueryField) => {
        if (!fields || !qf.code || !fields[qf.code]) {
            return `Unknown Field (${qf.code})`; // Fallback for missing fields
        }

        let name = fields[qf.code].name;
        if (qf.aggtype) {
            name = `${name} (${_.upperFirst(qf.aggtype)})`;
        }
        return name;
    };

    const tableHeaders: Cell[][] = []

    const headers: Cell[] = []
    columns.forEach(i => headers.push({id: index++, value: getName(i)}))

    const joinedHeaders = rows.map(i => getName(i))
    joinedHeaders.push(...values.map(i => getName(i)))

    const value = joinedHeaders.join(', ')
    headers.push({id: index++, value: value})
    tableHeaders.push(headers)

    const tableValues: Cell[][] = []
    if (columns.length > 0) {
        for (let i = 0; i < 5; i++) {
            const c: Cell[] = []
            for (let j = 0; j < columns.length; j++) {
                c.push({id: index++, value: getName(columns[j])})
            }
            tableValues.push([...c])
        }
    }

    return {
        headers: tableHeaders,
        values: tableValues
    }
}